import React, { useEffect, useState } from "react";
import Layout from "../../assets/Layout";
import UserLayout from "../../assets/UserLayout";
import { Box, Grid, IconButton, InputBase, Paper, TextField, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ProfileCard from "../Profile/ProfileCard";
import { useDispatch } from "react-redux";
import { getUsersByProfile } from "../../actions/userAuth";

export default function RecommendedCoach() {
  const [recommendedCoach, setRecommendedCoach] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUsersByProfile({ role: 'COACH' }, (data) => {
      setRecommendedCoach(data.data.data);
    }));
  }, []);

  return (
    <>
      <Layout>
        <UserLayout userRole={"candidate"}>

          <Box sx={{ display: 'flex', flexDirection: 'row', mt: 8, borderRadius: '10px' }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', width: '100%' }}> Recommended Coach</Typography>
            <Grid item md={4} sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', }}>
              {/* <TextField
                                sx={{ marginLeft: '1rem', backgroundColor: '#D9E3F6' }}
                                className='profile-skills-box text2Light'
                                variant="outlined"
                                size="small"
                                placeholder="Search"
                              
                                InputProps={{
                                    endAdornment: <SearchIcon sx={{ opacity: '0.5' }} />,
                                }}
                            /> */}
            </Grid>
          </Box>
          <Box px={4}>
            <Grid container spacing={4} mt={15}>
              {
                recommendedCoach && recommendedCoach.length > 0
                  ?
                  recommendedCoach.map((item, index) => (
                    <Grid item xs={12} md={4} key={index} mb={5}>
                      <ProfileCard coach={item}/>
                    </Grid>
                  ))
                  :
                  <Grid item xs={12} md={4} mb={5}>
                    <Typography align="center">No Coaches found</Typography>
                  </Grid>
              }
            </Grid>
          </Box>
        </UserLayout>
      </Layout>
    </>
  );
}
